export default __webpack_public_path__ + "static/media/banner-governance.8ca4e128.png";